import styled from 'styled-components';
import * as colors from '../../../common/colorConstants';

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
  margin-top: 4px;
`;

export const SearchButtonContainer = styled.div`
  position: relative;
`;

export const SearchTooltip = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  white-space: nowrap;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-family: 'Roboto', sans-serif;
  color: ${colors.filterTooltipText};
  background-color: ${colors.filterTooltipBg};
  border: 1px solid ${colors.filterTouchedBorder} !important;
  z-index: 1;

  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    right: 12px;
    border: 5px solid transparent;
    border-bottom-color: ${colors.filterTouchedBorder};
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    right: 13px;
    border: 4px solid transparent;
    border-bottom-color: ${colors.filterTooltipBg};
  }
`;
